import { convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";

export function fromEditorStateToHtml(editorState: EditorState) {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
}
